/**
 * Public Elyxeer pages both apps link out to.
 *
 * Brand-shaped, so they live here rather than in either app's i18n catalogue: the terms
 * a member accepts at sign-up and the ones the admin panel would cite are the same
 * document, and a URL that changed in one app but not the other would be a broken
 * promise rather than a broken link.
 */
export const BRAND_URL = "https://www.elyxeer.com";

/**
 * The storefront's customer-account area — where a member manages their Appstle
 * subscription (orders, deliveries, cancellation). Shopify redirects `/account`
 * to the new customer-accounts domain when the shop uses one, so this stays
 * stable either way.
 */
export const ACCOUNT_URL = `${BRAND_URL}/account`;

/**
 * A product's page on the storefront — where someone without a subscription is sent to
 * buy one. The handle comes from the live offerings, so a renamed product follows
 * without a release; without one, the storefront's home page is the honest fallback.
 */
export function productUrl(handle: string | null | undefined): string {
  return handle
    ? `${BRAND_URL}/products/${encodeURIComponent(handle)}`
    : BRAND_URL;
}

/**
 * Where a member writes when the app itself is the problem — sign-in, access, anything
 * technical. Brand-shaped for the same reason as the URLs above: the address printed in
 * the member app and the one the admin panel would quote have to be the same one.
 */
export const SUPPORT_EMAIL = "info@elyxeer.com";

/*
 * There is deliberately no LEGAL_LINKS here any more.
 *
 * The terms and the privacy policy used to be marketing-site URLs the sign-up screen
 * opened in a browser. The member app now carries counsel's text itself, at
 * `#/legal/<slug>` — public, offline, and the same revision as the one the member is
 * accepting. A constant pointing at a second copy on another site is exactly the
 * broken promise the note at the top of this file warns about, so it is gone rather
 * than left for someone to reach for.
 */
